// extracted by mini-css-extract-plugin
module.exports = {"button":"style-module__button___29Mph","disabled":"style-module__disabled___3xBYJ"};